@import "~@oebb-web-team/oebb-web-components/src/global/loading";
@import "../../global/forms";

.main-content .apartment-application {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 1.25rem;
    z-index: 0;
    height: 100%;

    &-form {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-self: stretch;
        height: 100%;
    }

    &-progress {
        display: flex;
        gap: 1rem;
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            z-index: 0;
            position: relative;
            min-width: 5rem;

            --progress-main-color: #999;
            --progress-step-color: #ccc;
            --progress-line-color: #999;

            &.apartment-application-progress-done {
                --progress-main-color: #51a351;
                --progress-step-color: #fff;
                --progress-line-color: #51a351;
            }

            &.apartment-application-progress-active {
                --progress-main-color: #e2002a;
                --progress-step-color: #fff;
                font-weight: bold;
            }
        }

        &-line {
            position: absolute;
            display: block;
            height: 0.75rem;
            left: 1rem;
            right: -1.5rem;
            top: 0.875rem;
            z-index: -1;
            background: var(--progress-line-color);
        }

        &-button {
            display: flex;
            flex-direction: column;
            align-items: start;
            background: none;
            width: auto;
            padding: 0;
            border: none;
            pointer-events: none;
        }

        &-point {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 2.5rem;
            height: 2.5rem;
            color: var(--progress-step-color);
            background: var(--progress-main-color);
            border-radius: 50%;
            pointer-events: auto;
        }

        &-text {
            font-size: 0.875rem;
            min-width: 2.5rem;
            color: var(--progress-main-color);
            pointer-events: auto;
        }

        @media screen and (max-width: 767px) {
            li {
                min-width: 3.5rem;
            }

            &-text {
                display: none;
            }
        }

        @media screen and (max-width: 567px) {
            gap: 0.75rem;

            li {
                min-width: unset;
            }

            &-line {
                height: 0.375rem;
                top: 0.6875rem;
            }

            &-point {
                width: 1.75rem;
                height: 1.75rem;
            }
        }
    }

    &-content {
        flex: 1 1;
        overflow: auto;
        overscroll-behavior: contain;
        margin: 0 -1.25rem 0.5rem;
        padding: 0.5rem 1.25rem;

        > :last-child {
            margin-bottom: 0;
        }
    }

    &-intro {
        font-weight: bold;
        margin-bottom: 1rem;
    }

    &-error {
        color: #e2002a;
        font-weight: bold;
        margin: 0;
    }

    &-loading {
        @include loading-indicator;
    }

    fieldset {
        padding-top: 0.75rem;
        margin: 0 0 1.25rem;
    }

    &-grid {
        display: grid;
        gap: 1.25rem;
        grid-template-columns: 1fr;
        margin-bottom: 1.25rem;

        @media screen and (min-width: 700px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media screen and (min-width: 1024px) {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    &-form-span {
        @media screen and (min-width: 700px) {
            grid-column: span 2;
        }
    }

    &-address-number {
        display: flex;
        gap: 1.25rem;
        align-items: center;

        > * {
            flex: 1;
            position: relative;
        }

        @media screen and (max-width: 1023px) {
            > :first-child {
                .form-label-text {
                    position: absolute;
                    white-space: nowrap;
                    overflow: visible;
                    z-index: 1;
                }
            }

            > :not(:first-child) {
                .form-label-text {
                    display: none;
                }
            }

            input {
                margin-top: 1.375rem;
            }
        }

        @media screen and (min-width: 1024px) {
            grid-column: span 2;
        }

        > :not(:first-child):before {
            content: "/";
            display: block;
            position: absolute;
            left: -0.8rem;
            bottom: 0.55rem;
            font-size: 1.5rem;
        }
    }

    &-address-city {
        display: flex;
        gap: 1.25rem;
        align-items: center;

        > label:first-child {
            flex: 0 0 30%;
        }

        > label:nth-child(2) {
            flex: 0 0 64%;
        }
    }
    
    &-required {
        @include form-required;
    }

    .form-invalid {
        input:invalid {
            @include form-invalid;
        }
    }

    &-label {
        @include form-label-vertical;
    }

    &-checkboxes {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;

        h3 {
            margin: 0;
        }

        label {
            display: flex;
            align-items: baseline;
        }

        p {
            margin: 0.25rem 0 0;
        }

        .form-label-text {
            font-weight: normal;
            margin: 0;
        }
    }

    &-gdpr {
        margin-top: 4rem;
    }

    &-flatmate-remove {
        grid-column-end: -1;
        align-self: end;
        justify-self: end;
        height: 3rem;
    }

    input[type="text"],
    input[type="number"],
    input[type="date"],
    input[type="email"],
    input[type="tel"] {
        @include form-input;
    }

    &-confirmation {
        h3 {
            margin: 0 0 1rem;
        }

        .apartments-row {
            table {
                table-layout: fixed;
                margin: 0;
            }

            th:first-child {
                width: 16rem;
                hyphens: auto;

                @media screen and (max-width: 450px) {
                    width: 9.5rem;
                }
            }

            td {
                word-wrap: break-word;
                overflow: hidden;
            }
        }

        .apartments-table-scroll {
            overflow-x: auto;
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }
    }

    &-done {
        margin: 2rem 0 0;
        font-weight: bold;
    }

    &-mail-help li a {
        color: #e2002a;
        text-decoration: none;
    }

    &-mail-help li a:hover {
        color: #ab0020;
    }

    &-buttons {
        display: flex;

        .apartment-application-loading {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 0.75rem;
        }
    }

    &-button {
        display: inline-flex;
        flex-direction: row;
        gap: 0.25rem;
        align-items: center;

        oebbx-icon {
            display: block;
        }

        svg {
            display: block;
            fill: currentColor;
            height: revert;
            width: revert;
            margin: 0;
        }

        &-primary {
            color: #fff;
            background: #e2002a;
            margin-left: auto;
            padding: 0.5rem 1rem;
            border: 1px solid #e2002a;

            &:focus,
            &:hover {
                color: #e2002a;
                background: #fff;
            }
        }

        &-secondary {
            color: #e2002a;
            padding: 0.25rem 0;
            border: none;
            background: none;

            &:focus,
            &:hover {
                text-decoration: underline;
            }
        }

        &-back {
            svg {
                transform: rotate(180deg);
            }
        }
    }

    @media screen and (max-width: 567px) {
        padding: 0.75rem;

        &-content {
            margin: 0 -0.75rem 0.5rem;
            padding: 0.5rem 0.75rem;
        }
    }

    .file-upload-info {
        padding: 1rem 0;
        display: block;
        font-style: italic;
        font-size: 0.95rem;

        a {
            color: #e2002a;
        }
    }

    .oebb-icon--info {
        margin: 5px 5px 5px 0;
        height: 15px;
        cursor: pointer;

        @media screen and (max-width: 567px) {
            height: 15px !important;
        }
    }

    .form-label-text-info {
        display: inline-block;
    }

    .apprentice__wrapper {
        display: inline-flex;
        gap: 1rem;
    }

    .radio-group {
        display: flex;
        gap: 20px;
        padding: 0.3rem;
    }

    input[type="radio"] {
        accent-color: var(--form-checkbox-color);
        margin: 0.25rem;
        height: 1.25rem;
        width: 1.25rem;
        flex-shrink: 0;
    }

    .custom-radio {
        padding: 0.25rem 0.5rem;
        position: relative;
        display: flex;
        align-items: center;
        gap: 0.25rem;

        &:hover {
            background-color: #F5F5F5;
        }
    }
}
